import {URL} from "../hooks/useRequest";

const masakParams = 'islem=masak_template&code='

export const getMasakTemplate = ({code, cookies}) => {
    let result = [];
    fetch(URL + masakParams + code, {
        method: "GET",
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            "Authorization": cookies.token
        },
    }).then(response => {
            if (response.ok) {
                return response.json()
            }
        }).then(data => {
            result = data;
            return data;
        })
    return result;
}

export async function getMasak(code, params, callback) {
    fetch(URL + masakParams + code, {
        headers: {
            'Content-Type': 'application/json; charset=UTF-8',
            "Authorization": params?.token
        },
    }).then(res => res.json())
        .then(data => {
            callback(data)
        })
}

export function getMasakGetir(params, callback) {
    const formData = new FormData();
    formData.append("tc_no", params?.tc);

    fetch(URL + 'islem=masak_getir', {
        method: "POST",
        headers: {
            "Authorization": params?.token
        },
        body: formData
    })
        .then(response => {
            return response?.json();
        })
        .then(data => {
            callback(data);
        })
        .catch(error => {
            console.error("Error fetching data:", error);
        });
}
